import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import UserSubmitModal from './modal/UserSubmitModal'
import UpdateCacheConfirmationModal from './modal/UpdateCacheConfirmationModal'

export default class UserSubmitComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }

  oncreate(vnode) {
    super.oncreate(vnode);
  }

  view() {
    const u2diUserType9 = app.forum.attribute('u2diUserType9');
    const u2diUserType0 = app.forum.attribute('u2diUserType0');

    if(u2diUserType9===true){
      return (
        <div className="u2diSubmitButtonContainer">
          {Button.component({
              className: 'Button Button--primary u2diUpdateCacheButton',
              onclick: () => {
                app.modal.show(UpdateCacheConfirmationModal);
              }
            },
            app.translator.trans('ziven-u2di.forum.button-update-cache')
          )}
        </div>
      );
    }else{
      return (
        <div>
          <div className="u2diSubmitButtonContainer">
            {Button.component({
                className: 'Button Button--primary u2diSubmitItemButton',
                onclick: () => {
                  app.modal.show(UserSubmitModal,{from:"publish"});
                }
              },
              app.translator.trans(app.session.user===null?'ziven-u2di.forum.button-submit-item':'ziven-u2di.forum.button-submit-item-youke')
            )}
          </div>
        </div>
      );
    }
  }

}